import { render, staticRenderFns } from "./PantryPage.vue?vue&type=template&id=1ec81704&"
import script from "./PantryPage.vue?vue&type=script&lang=ts&"
export * from "./PantryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports